module.exports = __webpack_public_path__ + "static/media/sudaneze-man.649e04cc.svg";